// extracted by mini-css-extract-plugin
module.exports = {"commentsVote":"I1aff","locked":"I1afh","vote":"I1afj","voted":"I1afl","like":"I1afn","dislike":"I1afp"};